// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"I2-z","displaySixCardTiles":"J2-z"};